export default __webpack_public_path__ + "images/8174feeddde4fd62a54ef344fff5c53d-x-orchid.svg";